const dropdown = 1000;
const sticky = 1020;
const fixed = 1030;
const modalBackdrop = 1040;
const modal = 1050;
const popover = 1060;
const tooltip = 1070;

export default {
  dropdown,
  sticky,
  fixed,
  modalBackdrop,
  modal,
  popover,
  tooltip,
};
